import React from 'react';
import {FormattedMessage} from 'react-intl';

const SelectStore = () => {
  return <div className='select-a-store'>
    <div className='select-a-store-instructions'><FormattedMessage id="preferences.store.to.begin" />, <span className='blue'><FormattedMessage id="preferences.store.select.store" /></span> <FormattedMessage id="preferences.store.from.dropdown" /></div>
    <div className='select-a-store-image'><i className='bl bl-store' /></div>
  </div>;
};

export default SelectStore;
